import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';
import { itemService } from '@/services/item';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useItemAdd() {
    const route = useRoute();
    const router = useAppRouter();

    const model = reactive({
        feature: Number(route.query.feature),
        data: route.query.data as string,
        name: '',
        ruby: 0,
        quantity: null,
        imageFile: null
    });

    const validations = {
        feature: { required },
        data: { required },
        name: { required },
        ruby: { required, min: minValue(0), max: maxValue(32000) },
        quantity: { min: minValue(1), max: maxValue(100) }
    };

    const v$ = useVuelidate(validations, model);

    const actions = {
        create: useCrudActions().excuteAndNotify({
            validator: v$,
            request: () =>
                itemService.item.create(
                    model.feature,
                    model.data,
                    model.name,
                    model.ruby,
                    model.quantity,
                    model.imageFile
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_ITEM.SYSTEM.INDEX })
        })
    };

    return { model, v$, actions };
}
